import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface BackButtonProps {
  label: string;
  onClick: () => void;
}

export const BackButton = ({ label, onClick }: BackButtonProps) => {
  return (
    <Box
      sx={{
        position: 'sticky',
        top: 64,
        zIndex: 10,
        backgroundColor: 'background.default',
        py: 1,
        mb: 0.5,
      }}
    >
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={onClick}
        size="small"
      >
        {label}
      </Button>
    </Box>
  );
};
